module.exports = __webpack_public_path__ + "assets/img/microgaming.84828ecd.png";